<template>
    <div
        v-if="currentPercentage !== null"
        class="text-nowrap font-weight-bold d-flex align-items-center flex-grow-1">
        <el-progress
            :class="statusClass"
            :percentage="currentPercentage"
            :stroke-width="strokeWidth"
            :format="() => {}"
            class="flex-grow-1" />
        <div class="position-absolute ml-3 text-white">
            <slot name="label" />
        </div>
    </div>
</template>

<script>
export default {
    name: "ProjectProgressBar",
    props: {
        percentage: {
            type: Number,
            required: true
        },
        notAnimated: {
            type: Boolean,
            default: false
        },
        strokeWidth: {
            type: Number,
            default: 30
        }
    },
    data() {
        return {
            currentPercentage: 0
        }
    },
    computed: {
        statusClass() {
            if (this.percentage >= 100) {
                return "status-green";
            } else {
                return "status-primary";
            }
        }
    },
    mounted() {
        if (this.notAnimated)
            this.currentPercentage = this.percentage
        else
            setTimeout(() => this.currentPercentage = this.percentage, 100)
    }
}
</script>

<style lang="scss" scoped>

:deep(.el-progress .el-progress-bar) {
    padding-right: 0;
    margin-right: 0;
}


:deep(.el-progress .el-progress-bar .el-progress-bar__outer) {
    background-color: $gray-500;
}

:deep(.el-progress.status-green .el-progress-bar .el-progress-bar__inner) {
    background-color: $success;
}

:deep(.el-progress.status-primary .el-progress-bar .el-progress-bar__inner) {
    background-color: var(--custom-primary-color);
}


</style>
